export const collectionConstants = {
    GET_COLLECTIONS_REQUEST: 'GET_COLLECTIONS_REQUEST',
    GET_COLLECTIONS_SUCCESS: 'GET_COLLECTIONS_SUCCESS',
    GET_COLLECTIONS_FAILURE: 'GET_COLLECTIONS_FAILURE',

    POST_UPLOAD_COLLECTIONS_REQUEST: 'POST_UPLOAD_COLLECTIONS_REQUEST',
    POST_UPLOAD_COLLECTIONS_SUCCESS: 'POST_UPLOAD_COLLECTIONS_SUCCESS',
    POST_UPLOAD_COLLECTIONS_FAILURE: 'POST_UPLOAD_COLLECTIONS_FAILURE',

    POST_AUTH_REQUEST: 'POST_AUTH_REQUEST',
    POST_AUTH_SUCCESS: 'POST_AUTH_SUCCESS',
    POST_AUTH_FAILURE: 'POST_AUTH_FAILURE'
};